<template>
  <div>
    <div class="cm-filter-select" @click="showSelectUsers = true">
      <v-icon :disabled="loading">mdi-account-multiple </v-icon>
      <p style="color: #182A47 !important">{{ filtersText }}</p>
    </div>
    <Dialog icon="mdi-account-multiple" :width="700" :display="showSelectUsers" :title="'Select Users'" @close="showSelectUsers = false">
      <div style="padding: 5px 40px">
        <!-- users table filter -->
        <v-row>
          <v-col cols="5">
            <v-text-field v-model="search" style="margin-bottom: 10px" append-icon="mdi-magnify" label="search" single-line hide-details></v-text-field>
          </v-col>
        </v-row>

        <!-- select users table -->
        <v-data-table
          dense
          v-model="selected"
          :headers="headers"
          :items="users"
          :loading="loading"
          :search="search"
          show-select
          @toggle-select-all="selectAll"
        />

        <!-- actions -->
        <v-spacer></v-spacer>
        <div>
          <v-btn text @click="showSelectUsers = false">cancel</v-btn>
          <v-btn text :disabled="submitDisabled" @click="submit">ok</v-btn>
        </div>
      </div>
    </Dialog>
  </div>
  
</template>

<script>
import Dialog from '@/components/general/Dialog.vue'
import { Logger } from "aws-amplify"
const logger = new Logger("Select Users")

export default {
  components: {
    Dialog
  },

  props: {
    loading: {
      type: Boolean,
      default: () => false
    },

    users: {
      type: Array, 
      required: true
    },

    value: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      showSelectUsers: false,
      search: '',
      selected: [],
      lastSelected: [],
      headers: [
        {
          text: 'User',
          value: 'name',
          align: 'left'
        },
        {
          text: 'Email',
          value: 'email',
          align: 'left'
        }
      ]
    }
  },

  watch: {
    showSelectUsers(val) {
      if(!val) {
        this.$nextTick(() => {
          this.selected = JSON.parse(JSON.stringify(this.lastSelected))
        })
      }
    },

    value(val) {
      logger.debug("selected users updated", val)
      this.lastSelected = JSON.parse(JSON.stringify(val))
    }
  },

  computed: {
    filtersText() {
      return !this.lastSelected.length || this.lastSelected.length == this.users.length
        ? ' All users'
          : `${this.lastSelected.length} of ${this.users.length} users`
    },

    submitDisabled () {
      return this.selectedAndLastSelectedAreTheSame
    },

    selectedAndLastSelectedAreTheSame () {
      if(this.selected.length != this.lastSelected.length) {
        return false
      }

      let selectedIds = this.selected.map(i => i.id)
      let lastSelectedIds = this.lastSelected.map(i => i.id)

      for(let x = 0; x < selectedIds.length; x++) {
        if(!lastSelectedIds.includes(selectedIds[x])) {
          return false
        }
      }

      return true
    }
  },

  methods: {
    submit() {
      this.lastSelected = JSON.parse(JSON.stringify(this.selected))
      this.$emit('input', this.selected)
      this.showSelectUsers = false
    },

    selectAll () {
      logger.debug("select all")
      if(this.selected.length == this.users.length) {
        this.selected = []
      } else {
        this.selected = JSON.parse(JSON.stringify(this.users))
      }
    }
  }
}
</script>

<style lang="scss">
.cm-filter-select {
  display: flex;
  width: auto;

  &:hover {
    cursor: pointer !important;
  }

  p {
    padding: 0 !important;
    margin: 0 0 0 10px !important;
    font-weight: bold !important;
  }
}
</style>